(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Marketplace', Marketplace);

    Marketplace.$inject = ['$resource'];

    function Marketplace($resource) {
        var resourceUrl = 'api/marketplaces/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
